import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { Card } from '@salesforce/design-system-react';
import NoData from './NoData';

class NoDataScreen extends Component {
  render() {
    return (
      <Card
        heading=""
        className="dashboard-card dashboard-no-data"
        {...this.props}
      >
        <div className="asset-catalog">
          <NoData {...this.props} />
        </div>
      </Card>
    );
  }
}

NoDataScreen.propTypes = {
  intl: intlShape.isRequired,
  screen: PropTypes.string.isRequired,
  helpLink: PropTypes.string.isRequired
};

export default injectIntl(NoDataScreen);
